export default {"src":"/login-app/[GIT_HASH]/_next/static/media/dagster_reversed.648145bc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};